export const getStatusValue = (status) =>
  status && typeof status === "object" ? status.statusId : status;

export const isElegivelIanStatus = (status) => {
  if (getStatusValue(status) === "elegivelIan") return true;

  const statusName = status && status.statusNome;
  return (
    statusName &&
    statusName
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase() === "elegivel ian"
  );
};

export const buildDashboardStatusFilter = (statusId) => {
  const statuses = !statusId
    ? []
    : Array.isArray(statusId)
    ? statusId
    : [statusId];

  return {
    statusIds: statuses
      .map(getStatusValue)
      .filter((status) => Number.isInteger(Number(status)))
      .map(Number),
    elegivelIan: statuses.some(isElegivelIanStatus),
  };
};
